import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { fetchSaleInfo } from "."

export const useSaleInfo = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(fetchSaleInfo());
    }, [dispatch, fetchSaleInfo])
}